import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export interface Item {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: Item[];
  onClick?: (item: Item) => void;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, onClick }) => {
  return (
    <nav aria-label="breadcrumb">
      <ul className="flex gap-2 items-center p-0 m-0 list-none">
        {items.map((item, index) => {
          const isLastItem = index === items.length - 1;
          return (
            <React.Fragment key={index}>
              <li
                className={`text-nowrap ${
                  isLastItem ? 'text-gray-500 cursor-default' : 'text-black'
                }`}
              >
                {isLastItem ? (
                  <span className="text-sm font-medium pointer-events-none">
                    {item.label}
                  </span>
                ) : (
                  <Link
                    to={item.path || '#'}
                    className="text-sm font-medium hover:underline"
                    onClick={() => {
                      onClick?.(item);
                    }}
                  >
                    {item.label}
                  </Link>
                )}
              </li>
              {!isLastItem && (
                <ChevronRight
                  className="text-gray-400"
                  style={{
                    fontSize: '14px',
                    width: '20px',
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumb;
